module.exports = __webpack_public_path__ + "static/4_2_recommendation_RO-86c16e6e97f5529626028adcffb3b08a.svg";